<template>
    <footer class="footer has-cardsX">

        <div class="container">
            <div class="row align-items-center my-md-2">
                <div class="col-lg-2 col-md-4 col-6">
                    <img src="/img/brand/logos/1mujeres.png" width="150px" />
                </div>
                <div class="col-lg-2 col-md-4 col-6">
                    <img src="/img/brand/logos/2reveldia.png" width="150px" />
                </div>
                <div class="col-lg-2 col-md-4 col-6">
                    <img src="/img/brand/logos/3Gregoria.png" width="150px" />
                </div>
                <div class="col-lg-2 col-md-4 col-6">
                    <img src="/img/brand/logos/4Reveldia.png" width="150px" />
                </div>
                <div class="col-lg-2 col-md-4 col-6">
                    <img src="/img/brand/logos/5-Coordinadopra.png" width="150px" />
                </div>
                <div class="col-lg-2 col-md-4 col-6">
                    <img src="/img/brand/logos/6oxfam.png" width="150px" />
                </div>
            </div>
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6 btn-wrapper text-center">
                    <img src="/img/brand/logo_canada.png" height="120" />
                </div>
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2" style="font-size:1.5rem; color: #873693 !important">Con el apoyo financiero del</h3>
                    <h4 class="mb-0 font-weight-light" style="color: #873693 !important">Gobierno de Canadá a través de Asuntos Mundiales Canadá</h4>
                </div>                
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright" style="color: #873693 !important">
                        &copy; 2021
                        <a href="https://mujeresyjusticiafiscal.org" target="_blank" style="color: #873693 !important">Observatorio de Justicia Fiscal desde las Mujeres</a>.
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <li class="nav-item" style="">
                             <a href="https://enteractive.com.bo/" class="nav-link" target="_blank">Desarrollado por ENTERACTIVE</a>
                        </li>
                        <!--
                        <li class="nav-item">
                            <a href="#" class="nav-link" target="_blank">Acerca</a>
                        </li>
                        -->
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
